function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useAbleToProvider } from '../../provider';
import styled from 'styled-components';
import { breakpoint } from '../../theme/breakpoints';
import { MAX_COLUMNS } from '../config';
export const calculateColumnSize = (size = 1) => {
  return size / MAX_COLUMNS * 100;
};
const Wrapper = styled.div`
  ${({
  smOffset,
  sm
}) => sm && `grid-column: ${smOffset || `span ${sm}`} / span ${sm};`}

  ${breakpoint.md`
    ${({
  mdOffset,
  md
}) => md && `grid-column: ${mdOffset || `span ${md}`} / span ${md};`}
  `}

  ${breakpoint.lg`
    ${({
  lgOffset,
  lg
}) => lg && `grid-column: ${lgOffset || `span ${lg}`} / span ${lg};`}
  `}
`;
const WrapperFlex = styled.div`
  box-sizing: border-box;
  flex: 0 0 auto;
  padding-right: var(--grid-gap-half);
  padding-left: var(--grid-gap-half);
  width: 100%;
  ${({
  sm = 1
}) => `max-width: ${calculateColumnSize(sm)}%;`}
  ${({
  smOffset
}) => smOffset && `margin-left: ${calculateColumnSize(smOffset)}%;`}

  ${breakpoint.md`
    ${({
  md = 1
}) => `max-width: ${calculateColumnSize(md)}%;`};
    ${({
  mdOffset
}) => mdOffset && `margin-left: ${calculateColumnSize(mdOffset)}%;`}
  `}

  ${breakpoint.lg`
    ${({
  lg = 1
}) => `max-width: ${calculateColumnSize(lg)}%;`};
    ${({
  lgOffset
}) => lgOffset && `margin-left: ${calculateColumnSize(lgOffset)}%;`}
  `}
`;
export const Column = ({
  children,
  ...props
}) => {
  const {
    flex = false
  } = useAbleToProvider();
  const Component = flex ? WrapperFlex : Wrapper;
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    "data-testid": "column"
  }), children);
};
export default Column;
//# sourceMappingURL=index.js.map